import { Loader2 } from 'lucide-react'
import type { ChargebackAddNotesProps } from '../../types/components'
import {
  CHARGEBACK_DETAIL_LABEL_CLASS,
  CHARGEBACK_DETAIL_SECONDARY_BUTTON_CLASS,
  CHARGEBACK_DETAIL_TEXTAREA_CLASS,
} from '../../constants/chargebackDetailConstants'

/** Shared so the Decision and History tabs keep an identical notes layout. */
export function ChargebackAddNotes({
  noteDraft,
  setNoteDraft,
  saving,
  addNote,
  helperText,
}: ChargebackAddNotesProps) {
  return (
    <div className="space-y-2 md:w-1/2">
      <div className="flex items-center justify-between gap-3">
        <span className={CHARGEBACK_DETAIL_LABEL_CLASS}>Add Notes</span>
        <button
          type="button"
          disabled={!noteDraft.trim() || saving}
          onClick={() => void addNote()}
          className={CHARGEBACK_DETAIL_SECONDARY_BUTTON_CLASS}
        >
          {saving ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : null}
          Add
        </button>
      </div>
      <textarea
        rows={3}
        placeholder="Type your notes here..."
        className={CHARGEBACK_DETAIL_TEXTAREA_CLASS}
        value={noteDraft}
        onChange={(event) => setNoteDraft(event.target.value)}
      />
      {helperText ? <p className="text-xs text-slate-500">{helperText}</p> : null}
    </div>
  )
}
